import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { mapActions, mapGetters, mapMutations } from "vuex";
import eventHub from "./eventHub";
import axios, { AxiosPromise } from "axios";
// import { ResponseMessage, MessageType } from "./models/messageModels";
import splashScreen from "./components/splashScreen.vue";
import moment from "moment";
import { MessageType, responseMessage } from "./models/messageModels";
import baseUserContextComponent from "./components/baseUserContextComponent";
import { UserLoggedInfoModel } from "./models/userModels";

@Component({
	methods: {
		...mapMutations(["setWindowSize", "setUser"]),
		...mapActions(["updateUserInfo", "logoutUser"])
	}
})
export default class App extends baseUserContextComponent {
	setWindowSize!: (size: any | null) => void;
	setUser!: (user: UserLoggedInfoModel | null) => void;
	updateUserInfo!: () => Promise<UserLoggedInfoModel>;
	logoutUser!: () => Promise<boolean>;
	_layout: string = "default-layout";
	onAxiosResponseError(error: any) {
		var instance = this;

		if (error.response == null) {
			instance.$bvToast.toast(error.message, {
				variant: "danger",
				title: "Si è verificato un errore",
				solid: true
			});
		} else if (error.response.status == 401) {
			instance.logoutUser();
			// instance.setUser(null);
			instance.$router.push({ name: "login" });
		} else if (error.response.status == 400) {
			if (
				error.response.data != null &&
				error.response.data.messages != null &&
				Array.isArray(error.response.data.messages)
			) {
				(error.response.data.messages as Array<
					responseMessage
				>).forEach(x => {
					instance.$bvToast.toast(x.text, {
						variant:
							x.type == null || x.type == MessageType.error
								? "danger"
								: x.type == MessageType.warning
								? "warning"
								: "info",
						title: x.code,
						solid: true
					});
				});
			} else {
				instance.$bvToast.toast(
					error.response.data && error.response.data.text
						? error.response.data.text
						: error.message,
					{
						variant: "danger",
						title: "",
						solid: true
					}
				);
			}
		} else if (error.response.status == 500) {
			instance.$bvToast.toast(error.message, {
				variant: "danger",
				title: "Si è verificato un errore",
				solid: true
			});
		}
	}
	onResize(event) {
		//console.log("window has been resized", event);
		this.setWindowSize({
			width: window.innerWidth,
			height: window.innerHeight
		});
	}
	beforeDestroy() {
		// Unregister the event listener before destroying this Vue instance
		window.removeEventListener("resize", this.onResize);
	}
	beforeMount() {
		var instance = this;
	}
	mounted() {
		var instance = this;

		window.addEventListener("resize", instance.onResize);
		instance.$nextTick(function() {
			// Code that will run only after the
			// entire view has been rendered
			instance.onResize(null);
		});
	}
	beforeCreate() {}
	created() {
		var instance = this;

		moment.locale(instance.getAppCulture);
		//to do: load numerlLocale based on appculture

		// this.$router.beforeEach((to, from, next) => {
		//   (instance as any).$insProgress.start();
		//   next();
		// });
		// this.$router.afterEach(() => {
		//   (instance as any).$insProgress.finish();
		// });

		eventHub.$on(
			eventHub.events.AXIOS_RESPONSE_ERROR,
			instance.onAxiosResponseError
		);
	}
	// @Watch("$route")
	// onRouteChange(to, from) {
	// 	debugger;
	// 	Vue.nextTick(() => {
	// 		if (!this.$route.meta.layout) this._layout = "default-layout";
	// 		else {
	// 			let componentExists =
	// 				this.$route.meta.layout in this.$options.components;

	// 			this._layout = componentExists
	// 				? this.$route.meta.layout
	// 				: "default-layout";
	// 		}
	// 	});
	// }
	get layout(): string {
		// if (!this.$route.meta.layout) return "empty-layout";
		// let componentExists =
		// 	this.$route.meta.layout in this.$options.components;

		// if (!componentExists) return "empty-layout";
		// return this.$route.meta.layout;
		if (
			this.$route.meta.layout &&
			this.$route.meta.layout in this.$options.components
		)
			return this.$route.meta.layout;
		return "default-layout";
	}
	get test():string{
		return this.$route.meta.layout;
	}
}
